export function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
}



//////////////////
// WEBPACK FOOTER
// ./~/aurelia-validation/dist/native-modules/util.js
// module id = 149
// module chunks = 0